export enum SinchStatusType {
    IsInCall = 1,
    OutOfCall = 2,
    Fetching = 3,
    Initiating = 4,
    Ringing = 5,
    Answered = 6,
    Hangup = 7
}